// Uygulama rotaları: hem sekme içeriği hem de sekme başlıkları buradan üretilir
// openInPlace: sayfa yeni sekmede değil, onu açan sekmenin içinde açılır (Geri ile önceki sayfaya dönülür)
import ColorListPage from "../pages/color/ColorListPage";
import ColorSubmitPage from "../pages/color/ColorSubmitPage";
import ColorEditPage from "../pages/color/ColorEditPage";
import PatternListPage from "../pages/pattern/PatternListPage";
import PatternSubmitPage from "../pages/pattern/PatternSubmitPage";
import PatternEditPage from "../pages/pattern/PatternEditPage";
import OperationListPage from "../pages/operation/OperationListPage";
import OperationSubmitPage from "../pages/operation/OperationSubmitPage";
import OperationEditPage from "../pages/operation/OperationEditPage";
import LocationListPage from "../pages/location/LocationListPage";
import LocationSubmitPage from "../pages/location/LocationSubmitPage";
import LocationEditPage from "../pages/location/LocationEditPage";
import ProductListPage from "../pages/product/ProductListPage";
import ProductSubmitPage from "../pages/product/ProductSubmitPage";
import WeightListPage from "../pages/weight/WeightListPage";
import WeightSubmitPage from "../pages/weight/WeightSubmitPage";
import WeightEditPage from "../pages/weight/WeightEditPage";
import ProductEditPage from "../pages/product/ProductEditPage";
import SupplierListPage from "../pages/supplier/SupplierListPage";
import SupplierSubmitPage from "../pages/supplier/SupplierSubmitPage";
import SupplierEditPage from "../pages/supplier/SupplierEditPage";
import OutsourcerListPage from "../pages/outsourcer/OutsourcerListPage";
import OutsourcerSubmitPage from "../pages/outsourcer/OutsourcerSubmitPage";
import OutsourcerEditPage from "../pages/outsourcer/OutsourcerEditPage";
import CustomerListPage from "../pages/customer/CustomerListPage";
import CustomerSubmitPage from "../pages/customer/CustomerSubmitPage";
import CustomerEditPage from "../pages/customer/CustomerEditPage";
import PurchaseListPage from "../pages/purchase/PurchaseListPage";
import PurchaseAddPage from "../pages/purchase/PurchaseAddPage";
import PurchaseEditPage from "../pages/purchase/PurchaseEditPage";
import ProductionRecordListPage from "../pages/production-record/ProductionRecordListPage";
import ProductionRecordAddPage from "../pages/production-record/ProductionRecordAddPage";
import ProductionRecordEditPage from "../pages/production-record/ProductionRecordEditPage";
import PlanShipment from "../pages/production-record/PlanShipment";
import PlanCompletePage from "../pages/production-record/PlanCompletePage";
import OrderListPage from "../pages/order/OrderListPage";
import OrderAddPage from "../pages/order/OrderAddPage";
import OrderEditPage from "../pages/order/OrderEditPage";
import OrderShipmentPage from "../pages/order/OrderShipmentPage";
import StockListPage from "../pages/stock/StockListPage";
import SupplierPaymentPage from "../pages/supplier/SupplierPaymentPage";
import AccountListPage from "../pages/account/AccountListPage";
import AccountAddPage from "../pages/account/AccountAddPage";
import AccountEditPage from "../pages/account/AccountEditPage";
import PaymentListPage from "../pages/payment/PaymentListPage";
import PaymentAddPage from "../pages/payment/PaymentAddPage";
import PaymentEditPage from "../pages/payment/PaymentEditPage";
import StockAddPage from "../pages/stock/StockAddPage";
import StockEditPage from "../pages/stock/StockEditPage";
import UserListPage from "../pages/user/UserListPage";
import UserAddPage from "../pages/user/UserAddPage";
import UserEditPage from "../pages/user/UserEditPage";
import UserEditPasswordPage from "../pages/user/UserEditPasswordPage";
import DashboardPage from "../pages/DashboardPage";
import VariationListPage from "../pages/product/VariationListPage";
import ChequeListPage from "../pages/cheque/ChequeListPage";
import ChequeAddPage from "../pages/cheque/ChequeAddPage";
import ChequeEditPage from "../pages/cheque/ChequeEditPage";
import OutsourcerPaymentPage from "../pages/outsourcer/OutsourcerPaymentPage";
import CustomerPaymentPage from "../pages/customer/CustomerPaymentPage";
import PurchaseReturnPage from "../pages/returnment/PurchaseReturnPage";
import ReturnmentHistoryPage from "../pages/returnment/ReturnmentHistoryPage";
import OrderReturnPage from "../pages/returnment/OrderReturnPage";

export const appRoutes = [
    { path: '/color', title: 'Renkler', Component: ColorListPage },
    { path: '/color/add', title: 'Renk Ekle', Component: ColorSubmitPage, openInPlace: true },
    { path: '/color/edit/:id', title: 'Renk Düzenle', Component: ColorEditPage },

    { path: '/pattern', title: 'Desenler', Component: PatternListPage },
    { path: '/pattern/add', title: 'Desen Ekle', Component: PatternSubmitPage, openInPlace: true },
    { path: '/pattern/edit/:id', title: 'Desen Düzenle', Component: PatternEditPage },

    { path: '/operation', title: 'İşlemler', Component: OperationListPage },
    { path: '/operation/add', title: 'İşlem Ekle', Component: OperationSubmitPage, openInPlace: true },
    { path: '/operation/edit/:id', title: 'İşlem Düzenle', Component: OperationEditPage },

    { path: '/location', title: 'Lokasyonlar', Component: LocationListPage },
    { path: '/location/add', title: 'Lokasyon Ekle', Component: LocationSubmitPage, openInPlace: true },
    { path: '/location/edit/:id', title: 'Lokasyon Düzenle', Component: LocationEditPage },

    { path: '/weight', title: 'Gramajlar', Component: WeightListPage },
    { path: '/weight/add', title: 'Gramaj Ekle', Component: WeightSubmitPage, openInPlace: true },
    { path: '/weight/edit/:id', title: 'Gramaj Düzenle', Component: WeightEditPage },

    { path: '/product', title: 'Ürünler', Component: ProductListPage },
    { path: '/product/add', title: 'Ürün Ekle', Component: ProductSubmitPage, openInPlace: true },
    { path: '/product/edit/:id', title: 'Ürün Düzenle', Component: ProductEditPage },
    { path: '/product/:id', title: 'Varyasyonlar', Component: VariationListPage },

    { path: '/supplier', title: 'Tedarikçiler', Component: SupplierListPage },
    { path: '/supplier/add', title: 'Tedarikçi Ekle', Component: SupplierSubmitPage, openInPlace: true },
    { path: '/supplier/edit/:id', title: 'Tedarikçi Düzenle', Component: SupplierEditPage },
    { path: '/supplier/:id/payment', title: 'Tedarikçi Ödeme', Component: SupplierPaymentPage },

    { path: '/outsourcer', title: 'Fasoncular', Component: OutsourcerListPage },
    { path: '/outsourcer/add', title: 'Fasoncu Ekle', Component: OutsourcerSubmitPage, openInPlace: true },
    { path: '/outsourcer/edit/:id', title: 'Fasoncu Düzenle', Component: OutsourcerEditPage },
    { path: '/outsourcer/:id/payment', title: 'Fasoncu Ödeme', Component: OutsourcerPaymentPage },

    { path: '/customer', title: 'Müşteriler', Component: CustomerListPage },
    { path: '/customer/add', title: 'Müşteri Ekle', Component: CustomerSubmitPage, openInPlace: true },
    { path: '/customer/edit/:id', title: 'Müşteri Düzenle', Component: CustomerEditPage },
    { path: '/customer/:id/payment', title: 'Müşteri Ödeme', Component: CustomerPaymentPage },

    { path: '/purchase', title: 'Satın Alımlar', Component: PurchaseListPage },
    { path: '/purchase/add', title: 'Satın Alım Ekle', Component: PurchaseAddPage, openInPlace: true },
    { path: '/purchase/edit/:id', title: 'Satın Alım Düzenle', Component: PurchaseEditPage },

    { path: '/account', title: 'Hesaplar', Component: AccountListPage },
    { path: '/account/add', title: 'Hesap Ekle', Component: AccountAddPage, openInPlace: true },
    { path: '/account/edit/:id', title: 'Hesap Düzenle', Component: AccountEditPage },

    { path: '/production-record', title: 'Üretim Kayıtları', Component: ProductionRecordListPage },
    { path: '/production-record/add', title: 'Üretim Ekle', Component: ProductionRecordAddPage, openInPlace: true },
    { path: '/production-record/edit/:id', title: 'Üretim Düzenle', Component: ProductionRecordEditPage },
    { path: '/production-record/:productionRecordId/plan/:planId/shipping', title: 'Üretim Sevkiyat', Component: PlanShipment },
    { path: '/production-record/:productionRecordId/plan/:planId/complete', title: 'Üretim Tamamla', Component: PlanCompletePage },

    { path: '/order', title: 'Siparişler', Component: OrderListPage },
    { path: '/order/add', title: 'Sipariş Ekle', Component: OrderAddPage, openInPlace: true },
    { path: '/order/edit/:id', title: 'Sipariş Düzenle', Component: OrderEditPage },
    { path: '/order/:orderId/shipment', title: 'Sipariş Sevkiyat', Component: OrderShipmentPage },

    { path: '/stock', title: 'Stok', Component: StockListPage },
    { path: '/stock/add', title: 'Stok Ekle', Component: StockAddPage, openInPlace: true },
    { path: '/stock/edit/:id', title: 'Stok Düzenle', Component: StockEditPage },

    { path: '/payment', title: 'Ödemeler', Component: PaymentListPage },
    { path: '/payment/add', title: 'Ödeme Ekle', Component: PaymentAddPage, openInPlace: true },
    { path: '/payment/edit/:id', title: 'Ödeme Düzenle', Component: PaymentEditPage },

    { path: '/user', title: 'Kullanıcılar', Component: UserListPage },
    { path: '/user/add', title: 'Kullanıcı Ekle', Component: UserAddPage, openInPlace: true },
    { path: '/user/edit/:id', title: 'Kullanıcı Düzenle', Component: UserEditPage },
    { path: '/user/edit-password/:id', title: 'Şifre Değiştir', Component: UserEditPasswordPage },

    { path: '/cheque', title: 'Çekler', Component: ChequeListPage },
    { path: '/cheque/add', title: 'Çek Ekle', Component: ChequeAddPage, openInPlace: true },
    { path: '/cheque/edit/:id', title: 'Çek Düzenle', Component: ChequeEditPage },

    { path: '/returnment/purchase/:id', title: 'Satın Alım İadesi', Component: PurchaseReturnPage },
    { path: '/returnment/order/:id', title: 'Sipariş İadesi', Component: OrderReturnPage },

    { path: '/returnment-archive', title: 'İadeler', Component: ReturnmentHistoryPage },

    { path: '/', title: 'Dashboard', Component: DashboardPage },
]
